import React from 'react'
import { GeoJSONLayer } from 'react-mapbox-gl'

export default function BuildingLayer(props) {
  return (
    <GeoJSONLayer
      id="building-geojson-layer"
      data={props.geojson}
      linePaint={{
        'line-color': '#8a746f',
        'line-width': 1,
      }}
    />
  )
}
